import {
    apiRequest,
    HDdetail,
    HDUploadSK,
} from "../../../../../services/adapters/kepegawaian/hukumanDisiplinService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", HDdetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", HDUploadSK, {
            body: query
        }, true)
    }
}

export default UpdateRepository